import React from 'react'

import { Badge, Icon, Tooltip, type TooltipProps } from '../../module'
import styles from './_unsorted-column.module.scss'
import { createTwoLineLabel } from '../../services/tableHelperFunctions'

type UnsortedColumnTooltipProps = {
  /** Define the tooltip content */
  content: TooltipProps['tooltipContent']
  /** Position for the tooltip */
  position?: TooltipProps['position']
}

type UnsortedColumnProps = {
  /** Unique label for the unsorted column headers. */
  label: string
  /** Define the tooltip for a column. */
  tooltip?: UnsortedColumnTooltipProps
  /** Class name for a column. */
  className?: string
  /** This prop will provide extra space for the column when the `showStickyClasses` boolean is `true` in our tables. */
  extraSpaceWhenStickyColumn?: boolean
  /** Optional boolean to add beta tag to header */
  beta?: boolean
  /** Optional boolean to split the label into two lines */
  twoLineLabel?: boolean
}

const UnsortedColumn = ({
  label,
  tooltip,
  className = '',
  extraSpaceWhenStickyColumn,
  beta,
  twoLineLabel,
}: UnsortedColumnProps): React.JSX.Element => {
  return (
    <span
      className={`${styles.unsortColumnContainer} ${className} ${
        extraSpaceWhenStickyColumn ? styles.extraSpace : ''
      }`}
    >
      {createTwoLineLabel(label, twoLineLabel)}
      {beta ? <Badge children='Beta' color='lavender' /> : null}
      {tooltip ? (
        <Tooltip
          tooltipContent={tooltip.content}
          position={tooltip.position ? tooltip.position : 'bottom'}
        >
          <Icon icon='info' color='dark-blue' iconSize='12px' />
        </Tooltip>
      ) : null}
    </span>
  )
}

export default UnsortedColumn
